<ng-template #overlayContent>
  @if (isVisible()) {
    <svg class="connector-line" [class.positioned]="isPositioned()">
      <path class="connector-path" [attr.d]="connectorPathData()" [attr.stroke]="connectorColor()" />
    </svg>

    <div
      #annotationBox
      class="annotation-box"
      [class.positioned]="isPositioned()"
      [class.arrow-anchor]="anchorStyle() === 'arrow'"
      [class.circle-anchor]="anchorStyle() === 'circle'"
      [class.elbow-90]="elbowAngle() === 90"
      [class.elbow-120]="elbowAngle() === 120"
    >
      <div class="annotation-content">
        <markdown [data]="latexContent()" katex [katexOptions]="katexOptions" />
      </div>
      <div #arrow class="annotation-arrow"></div>
    </div>
  }
</ng-template>
